export const DETAILS_HEADER = {
	line: 'Line:',
	tripNumber: 'Trip number:',
	rideUuid: 'UUID:',
	departure: 'Departure:',
	estimatedDuration: 'Estimated duration:',
	vehicles: 'Vehicle(s):',
	na: 'N/A',
};
